import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.css']
})
export class ContactDetailsComponent {


  @Input() showContactPopup = false;
  @Input() contactData: any;
  @Output() close = new EventEmitter<void>();

  
  closeContactPopup() {
    this.close.emit();
  }
}
